import { twMerge } from 'tailwind-merge';

import { Button, type ButtonProps } from './Button';
import { Spinner } from './Spinner';

interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
}

export function LoadingButton({
  isLoading = false,
  children,
  disabled,
  startIcon: startIconProp,
  className,
  ...props
}: LoadingButtonProps): React.ReactElement {
  const startIcon = isLoading ? <Spinner size="xs" /> : startIconProp;
  const classNames = twMerge('flex flex-row gap-2 items-center', className);

  return (
    <Button
      disabled={disabled || isLoading}
      startIcon={startIcon}
      className={classNames}
      {...props}
    >
      {children}
    </Button>
  );
}
